export const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

export const isEmail = (text: string) => emailPattern.test(text)

export const namePattern = /^[a-zA-ZÀ-ÿ\s'.-]+$/

export function findLastMatchingIndex(strings: string[], lookupString: string) {
  // reduceRight to find the "last" matching index
  return strings.reduceRight((acc, currentString, index) => {
    if (acc !== -1) {
      return acc
    }

    return currentString === lookupString ? index : acc
  }, -1)
}

export const youtubeIdPattern =
  /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\/|watch.*v=)|youtu\.be\/)([\w-]{11})/

export function findYoutubeId(videoUrl: string) {
  const found = videoUrl.match(youtubeIdPattern)
  return found ? found[1] : false
}
